module.exports = __webpack_public_path__ + "static/simon-sinek-d998eece65f1471b829e92d932d9d2fe.jpg";